<template>
    <cod-dialog
        class="note"
        :show.sync="showDialog"
    >
        <!-- Header -->
        <template slot="header">
            <v-toolbar-title>
                {{ $t('general.note_receipt') }}
            </v-toolbar-title>
        </template>

        <div class="pa-5" slot="content">
            <v-textarea
                v-model="noteInternal"
                :label="$t('general.note')"
                rows="2"
            />
        </div>

        <template slot="footer">
            <v-btn
                class="flex-1 mr-1"
                color="primary"
                outlined
                @click="showDialog = false"
            >
                {{ $t('general.close') }}
            </v-btn>

            <v-btn
                class="flex-1 ml-1"
                color="primary"
                depressed
                @click="save"
            >
                {{ $t('general.confirm') }}
            </v-btn>
        </template>
    </cod-dialog>
</template>

<script>
import CodDialog from '@/components/CodDialog';

export default {
    name: 'Note',

    components: {
        CodDialog,
    },

    props: {
        show: {
            type: Boolean,
            default: false
        },
        note: {
            type: String,
            default: () => {}
        }
    },

    created() {
    },

    data: () => ({
        showDialog: false,
        noteInternal: null,
    }),

    watch: {
        show(val) {
            this.showDialog = val;

            if(val) {
                this.$nextTick(() => {
                    this.noteInternal = this.note || null
                })
            }
        },

        showDialog(val) {
            this.$emit('update:show', val);
        },
    },

    methods: {
        save() {
            this.showDialog = false

            this.$emit('save', { note: this.noteInternal });
        }
    }
};
</script>

<style lang="scss" scoped>
.note {
}
</style>
